module.exports = __webpack_public_path__ + "static/media/Kauvery_Hospital_logo1.431ff06e.webp";